module.exports = __webpack_public_path__ + "img/icon-check-green.c9a5c89d.svg";